/** Default city highlighted on the store locator page (matches legacy `userLocation`). */
export const DEFAULT_STORE_LOCATOR_CITY = 'New Delhi';

/** Store locator page path. */
export const STORE_LOCATOR_PATH = '/store.html';

export function isStoreLocatorPathname(pathname: string): boolean {
  return pathname === STORE_LOCATOR_PATH;
}
